import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "px-6" }
const _hoisted_2 = { class: "py-2" }
const _hoisted_3 = { class: "py-2" }
const _hoisted_4 = { class: "my-4 flex justify-center gap-8" }

import {useStore} from 'vuex'
import {ref} from 'vue'
import DialogComponent from '@/components/doalog/DialogComponent.vue'

interface CouponGenericGenerate {
  operatorId: string,
  code: string,
  couponConditionId: number,
  expireHour: number,
}



export default /*#__PURE__*/_defineComponent({
  __name: 'GenerateGenericCouponDialog',
  props: { show: Boolean, couponGenerateData: Object as () => CouponGenericGenerate},
  emits: ['onGenerateCoupon', 'update:show'],
  setup(__props, { emit }) {

const props = __props



const store = useStore()

const form = ref({code: ``, expireHour: 0})


const onCreateCouponCondition = () => {
  const payload: CouponGenericGenerate = {
    operatorId: store?.state?.selectedOperator?.operatorId,
    code: form.value.code,
    couponConditionId: Number(props.couponGenerateData?.couponConditionId),
    expireHour: Number(form.value.expireHour),
  }

  emit('onGenerateCoupon', payload )
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DialogComponent, {
    title: _ctx.$t('messages.coupon.generate'),
    isOpen: __props.show
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createTextVNode(_toDisplayString(_ctx.$t('messages.coupon.code')) + " ", 1),
          _withDirectives(_createElementVNode("input", {
            name: "length",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.code) = $event)),
            type: "text",
            class: "w-full rounded-md"
          }, null, 512), [
            [_vModelText, form.value.code]
          ])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createTextVNode(_toDisplayString(_ctx.$t('messages.coupon.expireHour')) + " ", 1),
          _withDirectives(_createElementVNode("input", {
            name: "expireHour",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.expireHour) = $event)),
            type: "number",
            min: "0",
            step: "1",
            class: "w-full rounded-md"
          }, null, 512), [
            [_vModelText, form.value.expireHour]
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            type: "reset",
            class: "flex-1 bg-red-500 text-white p-1 px-4 rounded",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:show', false)))
          }, _toDisplayString(_ctx.$t('messages.coupon.cancel')), 1),
          _createElementVNode("button", {
            class: "flex-1 bg-blue-500 text-white p-1 px-4 rounded",
            onClick: onCreateCouponCondition
          }, _toDisplayString(_ctx.$t('messages.coupon.generate')), 1)
        ])
      ])
    ]),
    _: 1
  }, 8, ["title", "isOpen"]))
}
}

})